import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class MyHomeState {
  private myHomeListSub$ = new BehaviorSubject<any>([]);
  myHomeList$ = this.myHomeListSub$.asObservable();

  private activeHomeSub$ = new BehaviorSubject<any>({});
  activeHome$ = this.activeHomeSub$.asObservable();

  private mortgageListSub$ = new BehaviorSubject<any>([]);
  mortgageList$ = this.mortgageListSub$.asObservable();

  private activeHomeValuesSub$ = new BehaviorSubject<any>([]);
  activeHomeValues$ = this.activeHomeValuesSub$.asObservable();

  private activeHomeValuesLoaderSub$ = new BehaviorSubject<boolean>(true);
  activeHomeValuesLoader$ = this.activeHomeValuesLoaderSub$.asObservable();

  private selectedMortgageIndexSub$ = new BehaviorSubject<number>(0);
  selectedMortgageIndex$ = this.selectedMortgageIndexSub$.asObservable();

  private openSpendForecastSheetSub$ = new BehaviorSubject<boolean>(false);
  openSpendForecastSheet$ = this.openSpendForecastSheetSub$.asObservable();

  private activePropertyDetailsSub$ = new BehaviorSubject<any>({});
  activePropertyDetails$ = this.activePropertyDetailsSub$.asObservable();
  // private activeRefinanceSub$ = new BehaviorSubject<any>(null);

  constructor() { }

  public get selectedMortgageIndexValue() {
    return this.selectedMortgageIndexSub$.value;
  }

  public set selectedMortgageIndexValue(index) {
    this.selectedMortgageIndexSub$.next(index);
  }

  public get myHomeListValue() {
    return this.myHomeListSub$.value;
  }

  public set myHomeListValue(list) {
    this.myHomeListSub$.next(list);
  }

  public get mortgageListValue() {
    return this.mortgageListSub$.value;
  }

  public set mortgageListValue(list) {
    this.mortgageListSub$.next(list);
  }

  public get activeHomeValue() {
    return this.activeHomeSub$.value;
  }

  public set activeHomeValue(list) {
    this.activeHomeSub$.next(list);
  }

  public get activeHomePropertyValue() {
    return this.activeHomeValuesSub$.value;
  }

  public set activeHomePropertyValue(list) {
    this.activeHomeValuesSub$.next(list);
  }

  public get activeHomePropertyLoaderValue() {
    return this.activeHomeValuesLoaderSub$.value;
  }

  public set activeHomePropertyLoaderValue(status) {
    this.activeHomeValuesLoaderSub$.next(status);
  }

  public get openSpendForecastSheetValue(): boolean {
    return this.openSpendForecastSheetSub$.value;
  }

  public set openSpendForecastSheetValue(status: boolean) {
    this.openSpendForecastSheetSub$.next(status);
  }

  public get activePropertyDetailsValue(): object {
    return this.activePropertyDetailsSub$.value;
  }

  public set activePropertyDetailsValue(property: object) {
    this.activePropertyDetailsSub$.next(property);
  }

  private refinanceScenarioListSub$ = new BehaviorSubject<any>({});
  refinanceScenarioList$ = this.refinanceScenarioListSub$.asObservable();

  public get refinanceScenarioListValue(): object {
    return this.refinanceScenarioListSub$.value;
  }

  public set refinanceScenarioListValue(property: object) {
    this.refinanceScenarioListSub$.next(property);
  }

  private homeListUpdateSub$ = new BehaviorSubject<any>([]);
  homeListUpdate$ = this.homeListUpdateSub$.asObservable();

  public get homeListUpdateValue(): object {
    return this.homeListUpdateSub$.value;
  }

  public set homeListUpdateValue(property: object) {
    this.homeListUpdateSub$.next(property);
  }

  private DealAnalysisHomeValueSub$ = new BehaviorSubject<any>([]);
  DealAnalysisHome$ = this.DealAnalysisHomeValueSub$.asObservable();

  public get DealAnalysisHomeValue(): object {
    return this.DealAnalysisHomeValueSub$.value;
  }
  public set DealAnalysisHomeValue(property: object) {
    this.DealAnalysisHomeValueSub$.next(property);
  }

  isMyHomeAddressSub$ = new BehaviorSubject<boolean>(false);
  isMyHomeAddress = this.isMyHomeAddressSub$.asObservable();

  public get isMyHomeAddressValue() {
    return this.isMyHomeAddressSub$.value;
  }

  public set isMyHomeAddressValue(status: boolean) {
    this.isMyHomeAddressSub$.next(status);
  }

  isArticleSheetOpened$ = new BehaviorSubject<string>(null);
  isArticleSheet = this.isArticleSheetOpened$.asObservable();

  public get isArticleSheetOpenedValue() {
    return this.isArticleSheetOpened$.value;
  }

  public set isArticleSheetOpenedValue(status: string) {
    this.isArticleSheetOpened$.next(status);
  }
  // state for storing saved rental analysis data
  private myHomeRentalDealsSub$ = new BehaviorSubject<any>([]);
  myHomeDealsList$ = this.myHomeRentalDealsSub$.asObservable();

  public get rentalDealsListValue() {
    return this.myHomeRentalDealsSub$.value;
  }

  public set rentalDealsListValue(list) {
    this.myHomeRentalDealsSub$.next(list);
  }

  private savedEquityDataSub$ = new BehaviorSubject<any>(null);
  savedEquityData$ = this.savedEquityDataSub$.asObservable();

  public get savedEquityData() {
    return this.savedEquityDataSub$.value;
  }

  public set savedEquityData(data) {
    this.savedEquityDataSub$.next(data);
  }

  private customEquityDataSub$ = new BehaviorSubject<any>(null);
  customEquity$ = this.customEquityDataSub$.asObservable();

  public get customEquityData() {
    return this.customEquityDataSub$.value;
  }

  public set customEquityData(data) {
    this.customEquityDataSub$.next(data);
  }

  //end
}
